import * as React from 'react';
import {useEffect, useState} from "react";
import {withNamespaces, WithNamespaces} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {Redirect, RouteComponentProps} from "react-router";
import {Dimmer, Loader} from "semantic-ui-react";
import {ResponseType} from "../../api/util";
import {Action} from "../../InspectioBoards";
import {Action as Notify} from "../../NotificationSystem";
import {OrganizationId} from "../../Organization/model/Organization";
import * as Routes from "../../routes";
import * as User from "../../User";
import {makeGetCurrentUser} from "../../User/selectors/currentUser";
import {ackTeamInvitation, fetchTeamOfInvitation} from "../actions/api";
import {TeamName} from "../model/Team";

interface OwnProps {

}

interface RouteMatchParams {
    invitation: string;
}

type TeamInvitationProps = OwnProps & RouteComponentProps<RouteMatchParams> & WithNamespaces;

const TeamInvitation = (props: TeamInvitationProps) => {
    const invitationId = props.match.params.invitation;
    const currentUserSelector = makeGetCurrentUser();

    const currentUser = useSelector(currentUserSelector);
    const [doRedirect, setDoRedirect] = useState(false);

    const dispatch = useDispatch();

    useEffect(() => {
        if(currentUser.signedIn) {
            fetchTeamOfInvitation(invitationId)
            .then(({response, error}) => {
                if(error) {
                    dispatch(Notify.Command.error('Request failed', 'Failed to process team invitation'));
                    setDoRedirect(true);
                    return;
                }

                if(response) {
                    const teamName: TeamName = response.data.name;
                    const organizationId: OrganizationId = response.data.organizationId || null;

                    let retries = 0;

                    const handleAckResponse = (ackResponse: ResponseType) => {
                        if(ackResponse.error) {
                            // Invited user is new and username sync seems still be in progress
                            if(retries < 2) {
                                retries++;
                                window.setTimeout(() => {
                                    ackTeamInvitation(invitationId).then(handleAckResponse);
                                }, 100);
                                return;
                            }

                            dispatch(Notify.Command.error('Command failed', 'Failed to process team invitation'));
                            setDoRedirect(true);
                            return;
                        }

                        dispatch(Notify.Command.info(
                            props.t('insp.team.joined.title'),
                            props.t('insp.team.joined.details', {team: teamName}))
                        );

                        if(organizationId) {
                            dispatch(User.Action.Command.switchActiveOrganization(organizationId));
                        }

                        dispatch(Action.Query.fetchUserBoards());
                        setDoRedirect(true);
                    };

                    ackTeamInvitation(invitationId)
                        .then(handleAckResponse);
                }
            });
        }
    }, [currentUser.signedIn]);

    if(doRedirect) {
        return <Redirect to={Routes.inspectio} />
    }

    return <Dimmer active={true} className="page"><Loader size="large">Processing Team Invitation</Loader></Dimmer>;
};

export default  withNamespaces()(TeamInvitation);
